import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Login from "./modules/auth/login";
import RequestPassword from "./modules/auth/requestPassword";
import ResetPassword from "./components/resetPassword";
import Register from "./modules/auth/register";
import DashboardLayout from "./modules/dashboard/dashboardLayout";
import ViewDashboard from "./modules/dashboard/viewDashboard";
import Bitacora from "./modules/operativo/bitacora/bitacora";
import RecepcionistaDashboard from "./modules/dashboard/recepcionista/pages/RecepcionistaDashboard";
import DashboardSuperAdmin from "./modules/dashboard/superadmin/superadmin";
import ProfilePage from "./modules/dashboard/profile/ProfilePage";
import MenuConfig from "./modules/dashboard/configuracion/MenuConfig";
import ConfiguracionIndex from "./modules/dashboard/configuracion/components/ConfiguracionTabs";
import ConfiguracionBonificaciones from "./modules/dashboard/configuracion/ConfiguracionBonificaciones";
import ConfiguracionSistema from "./modules/dashboard/configuracion/ConfiguracionSistema";
import ConfiguracionCampus  from "./modules/dashboard/configuracion/ConfiguracionCampus";
import ConfiguracionDocumentos from "./modules/dashboard/configuracion/ConfiguracionDocumentos";
import ConfiguracionEntregables from "./modules/dashboard/configuracion/ConfiguracionEntregables";
import RequireAuth from "./components/RequireAuth";
import RequirePermission from "./components/RequirePermission";
import CentrosEducativos from "./modules/operativo/centro/centros";
import Empresas from "./modules/operativo/empresas/empresas";
import Niveles from "./modules/academico/niveles/niveles";
import Especialidades from "./modules/academico/especialidades/especialidades";
import Cursos from "./modules/academico/cursos/cursos";
import CoordinacionFormacion from "./modules/academico/catalogo/coordinacion";
import PlantillasFormacion from "./modules/academico/catalogo/plantillas";
import Ciclos from "./modules/academico/ciclos/ciclos";
import ConvocatoriaPlantillas from "./modules/academico/convocatoria-plantillas/convocatoria_plantillas";
import Promociones from "./modules/academico/promociones/promociones";
import PromocionInscritosView from "./modules/academico/promociones/pages/PromocionInscritosView.jsx";
import FichaInscritoPage from "./modules/academico/promociones/pages/FichaInscritoPage.jsx";
import Materias from "./modules/academico/materias/materias";
import Docentes from "./modules/academico/docentes/docentes";
import MallaView from "./modules/academico/malla/pages/MallaView";
import Usuarios from "./modules/seguridad/usuarios/usuarios";
import Roles from "./modules/seguridad/roles/roles";
import Estudiantes from "./modules/academico/estudiantes/estudiantes";
import Matriculas from "./modules/academico/matriculas/matriculas";
import Interesados from "./modules/operativo/interesados/interesados";
import Formaciones from "./modules/academico/formaciones/formaciones";
import Pagos from "./modules/financiero/pagos/pagos";
import Bonificaciones from "./modules/financiero/bonificaciones/bonificaciones";
import Comisionistas from "./modules/financiero/comisionistas/comisionistas";
import PersonasView from "./modules/financiero/personas/pages/PersonasView";
import Empleados from "./modules/rrhh/empleados/empleados";
import ComprasRegistradas from "./modules/rrhh/compras/ComprasRegistradas";
import ConfigContificoView from "./modules/seguridad/contifico/ConfigContificoView";
import ModulosSistemaView from "./modules/seguridad/modulos/ModulosSistemaView";
import FacturasEmitidasView from "./modules/financiero/facturacion/FacturasEmitidasView";
import ReporteCajaView from "./modules/financiero/caja/ReporteCajaView";
import Puestos from "./modules/rrhh/puestos/puestos";
import RegistroHoras from "./modules/rrhh/registroHoras/registroHoras";
import InventarioView from "./modules/inventario/InventarioView";
import DashboardSecretaria from "./modules/dashboard/secretaria/secretaria";
import AdministradorDashboard from "./modules/dashboard/administrador/pages/AdministradorDashboard";
import CajeroDashboard from "./modules/dashboard/cajero/pages/CajeroDashboard";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <>
        <Toaster
          position="top-right"
          gutter={12}
          toastOptions={{
            style: { background: "transparent", boxShadow: "none", padding: 0 },
            duration: 4000,
          }}
        />
        <Routes>
          <Route path="/ficha-inscrito/:matriculaId" element={<RequireAuth><FichaInscritoPage /></RequireAuth>} />
          <Route path="/" element={<Login />} />
          <Route path="/requestPassword" element={<RequestPassword />}></Route>
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<RequireAuth><DashboardLayout /></RequireAuth>}>
            <Route path="view_dashboard" element={<ViewDashboard />} />
            <Route index element={<ViewDashboard />} />
            <Route path="superadmin" element={<DashboardSuperAdmin />} />
            <Route path="recepcionista" element={<RecepcionistaDashboard />} />
            <Route path="secretaria" element={<DashboardSecretaria />} />
            <Route path="administrador" element={<AdministradorDashboard />} />
            <Route path="cajero" element={<CajeroDashboard />} />
            <Route path="perfil" element={<ProfilePage />} />
            <Route
              path="configuracion"
              element={
                <RequirePermission code="configuracion">
                  <ConfiguracionIndex />
                </RequirePermission>
              }
            />
            <Route
              path="configuracion/menus"
              element={
                <RequirePermission code="configuracion">
                  <MenuConfig />
                </RequirePermission>
              }
            />
            <Route
              path="configuracion/bonificaciones"
              element={
                <RequirePermission code="configuracion.bonificaciones">
                  <ConfiguracionBonificaciones />
                </RequirePermission>
              }
            />
            <Route
              path="configuracion/sistema"
              element={
                <RequirePermission code="configuracion">
                  <ConfiguracionSistema />
                </RequirePermission>
              }
            />
            <Route
              path="configuracion/campus"
              element={
                <RequirePermission code="configuracion">
                  <ConfiguracionCampus />
                </RequirePermission>
              }
            />
            <Route
              path="configuracion/documentos"
              element={
                <RequirePermission code="configuracion">
                  <ConfiguracionDocumentos />
                </RequirePermission>
              }
            />
            <Route
              path="configuracion/entregables"
              element={
                <RequirePermission code="configuracion">
                  <ConfiguracionEntregables />
                </RequirePermission>
              }
            />
            <Route path="admin/usuarios" element={<RequirePermission code="manage_users"><Usuarios /></RequirePermission>} />
            <Route path="admin/roles" element={<RequirePermission code="roles.gestion"><Roles /></RequirePermission>} />
            <Route path="centros" element={<RequirePermission code="centros.listar"><CentrosEducativos /></RequirePermission>} />
            <Route path="operativo/empresas" element={<RequirePermission code="empresas.listar"><Empresas /></RequirePermission>} />
            <Route
              path="coordinacion"
              element={
                <RequirePermission
                  anyOf={[
                    "coordinacion.acceso",
                    "coordinacion.listar",
                    "niveles.listar",
                    "especialidades.listar",
                    "cursos.listar",
                    "materias.listar",
                    "docentes.listar",
                    "malla.listar",
                  ]}
                >
                  <CoordinacionFormacion />
                </RequirePermission>
              }
            />
            <Route
              path="plantillas"
              element={
                <RequirePermission
                  anyOf={[
                    "convocatoria_plantillas.acceso",
                    "convocatoria_plantillas.listar",
                  ]}
                >
                  <PlantillasFormacion />
                </RequirePermission>
              }
            />
            <Route path="coordinacion/niveles" element={<RequirePermission code="niveles.listar"><Niveles /></RequirePermission>} />
            <Route path="bitacora" element={<RequirePermission code="bitacora.listar"><Bitacora /></RequirePermission>} />
            <Route path="coordinacion/especialidades" element={<RequirePermission code="especialidades.listar"><Especialidades /></RequirePermission>} />
            <Route path="coordinacion/cursos" element={<RequirePermission code="cursos.listar"><Cursos /></RequirePermission>} />
            <Route path="coordinacion/ciclos" element={<RequirePermission code="ciclos.listar"><Ciclos /></RequirePermission>} />
<Route path="plantillas/convocatoria-plantillas" element={<RequirePermission code="convocatoria_plantillas.listar"><ConvocatoriaPlantillas /></RequirePermission>} />
            <Route path="coordinacion/promociones" element={<RequirePermission code="promociones.listar"><Promociones /></RequirePermission>} />
            <Route
              path="coordinacion/promociones/:id/inscritos"
              element={
                <RequirePermission
                  anyOf={[
                    "promociones.inscritos.listar",
                    "promociones.notas.listar",
                    "promociones.diplomas.listar",
                    "calendario.listar",
                  ]}
                >
                  <PromocionInscritosView />
                </RequirePermission>
              }
            />
            <Route path="coordinacion/materias" element={<RequirePermission code="materias.listar"><Materias /></RequirePermission>} />
            <Route path="coordinacion/docentes" element={<RequirePermission code="docentes.listar"><Docentes /></RequirePermission>} />
            <Route path="coordinacion/malla" element={<RequirePermission code="malla.listar"><MallaView /></RequirePermission>} />
            <Route path="formaciones/*" element={<RequirePermission code="formaciones.listar"><Formaciones /></RequirePermission>} />
            <Route path="estudiantes/*" element={<RequirePermission code="estudiantes.listar"><Estudiantes /></RequirePermission>} />
            <Route path="matriculas/*" element={<RequirePermission code="matriculas.listar"><Matriculas /></RequirePermission>} />
            <Route path="caja/pagos/*" element={<RequirePermission code="pagos.listar"><Pagos /></RequirePermission>} />
            <Route path="caja/reporte" element={<RequirePermission code="pagos.reporte_caja"><ReporteCajaView /></RequirePermission>} />
            <Route path="caja/bonificaciones/*" element={<RequirePermission code="bonificaciones.listar"><Bonificaciones /></RequirePermission>} />
            <Route path="caja/comisionistas/*" element={<RequirePermission code="referentes.listar"><Comisionistas /></RequirePermission>} />
            <Route path="caja/personas" element={<RequirePermission code="personas.listar"><PersonasView /></RequirePermission>} />
            <Route path="recepcion/interesados" element={<RequirePermission code="interesados.listar"><Interesados /></RequirePermission>} />
            {/* Módulos del sistema — solo superadmin (rootOnly: sin bypass por permiso) */}
            <Route path="admin/modulos" element={<RequirePermission rootOnly><ModulosSistemaView /></RequirePermission>} />
            {/* Contífico — accesible con el permiso contifico.configurar (ej. administrador).
                Las credenciales (API Key/Token) están protegidas aparte, a nivel de superadmin,
                dentro de ConfigContificoView y en el backend (guardarConfig). */}
            <Route path="admin/contifico" element={<RequirePermission code="contifico.configurar"><ConfigContificoView /></RequirePermission>} />
            {/* Facturación electrónica */}
            <Route path="financiero/facturas" element={<RequirePermission code="contifico.listar"><FacturasEmitidasView /></RequirePermission>} />
            {/* RRHH — visible solo para superadmin mientras está en desarrollo */}
            <Route path="rrhh/empleados" element={<RequirePermission code="rrhh.empleados.listar"><Empleados /></RequirePermission>} />
            <Route path="rrhh/puestos" element={<RequirePermission code="rrhh.puestos.listar"><Puestos /></RequirePermission>} />
            <Route path="rrhh/registro-horas" element={<RequirePermission code="rrhh.registro_horas.listar"><RegistroHoras /></RequirePermission>} />
            <Route path="inventario" element={<RequirePermission code="inventario.listar"><InventarioView /></RequirePermission>} />
            <Route path="financiero/compras" element={<RequirePermission code="contifico.listar"><ComprasRegistradas /></RequirePermission>} />
            <Route path="*" element={<Navigate to="/dashboard/view_dashboard" replace />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </>
    </Router>
  );
}

export default App;
